// HRPolicies.js
import React, { useState, useEffect } from 'react';
import HrDashboardAside from './HrDashboardAside';
// import './Policies.css';

function Policies() {
    const [formData, setFormData] = useState({
        policyTitle: '',
        policyCategory: '',
        effectiveDate: '',
        reviewCycle: '',
        policyDescription: '',
        policyFile: null,
        policyStatus: '',
        approvedBy: '',
    });
    const [policies, setPolicies] = useState([]);

    useEffect(() => {
        loadPolicies();
    }, []);

    const loadPolicies = () => {
        fetch('https://cleezoclass.com:8443/api/get-policies')
            .then(response => response.json())
            .then(data => {
                if (data.policies && data.policies.length > 0) {
                    setPolicies(data.policies);
                    document.getElementById('policyTableContainer').style.display = 'block';
                } else {
                    alert('No policies found.');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('There was an error fetching the policies.');
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        setFormData({
            ...formData,
            policyFile: e.target.files[0],
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const form = new FormData();
        for (const key in formData) {
            form.append(key, formData[key]);
        }

        fetch('https://cleezoclass.com:8443/api/policies', {
            method: 'POST',
            body: form,
        })
            .then(response => response.json())
            .then(data => {
                if (data.message === 'Policy added successfully') {
                    alert('Policy added successfully');
                    loadPolicies();
                    setFormData({
                        policyTitle: '',
                        policyCategory: '',
                        effectiveDate: '',
                        reviewCycle: '',
                        policyDescription: '',
                        policyFile: null,
                        policyStatus: '',
                        approvedBy: '',
                    });
                } else {
                    alert('Error: ' + data.message);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('There was an error while adding the policy');
            });
    };

    return (
        <div className=" mainBlock">
            <HrDashboardAside />
            <h1>HR Policies</h1>

            {/* Add New Policy Form */}
            <h2>Add New Policy</h2>
            <div className='policyForm'>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="policyTitle">Policy Title</label>
                        <input
                            type="text"
                            id="policyTitle"
                            name="policyTitle"
                            value={formData.policyTitle}
                            onChange={handleChange}
                            placeholder="Enter policy title"
                        />
                    </div>

                    {/* Other form fields go here */}
                    {/* ... */}

                    <button type="submit">Add Policy</button>
                </form>
            </div>


            {/* Existing Policies Table */}
            <div className="table-container" id="policyTableContainer">
                <h2>Existing Policies</h2>
                
  <table id="policyTable">
                    <thead>
                        <tr>
                            <th>Policy Title</th>
                            <th>Category</th>
                            <th>Effective Date</th>
                            <th>Status</th>
                            <th>Review Cycle</th>
                            <th>Approved By</th>
                        </tr>
                    </thead>
                    <tbody>
                        {policies.map((policy, index) => (
                            <tr key={index}>
                                <td>{policy.policyTitle}</td>
                                <td>{policy.policyCategory}</td>
                                <td>{policy.effectiveDate}</td>
                                <td>{policy.policyStatus}</td>
                                <td>{policy.reviewCycle} months</td>
                                <td>{policy.approvedBy}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                </div>
              
        
        </div>

    );
}

export default Policies;
